var _clipPath, _clipPath2, _clipPath3, _clipPath4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 0h-400v300h400z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 300h-400v180h400z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 300h-400v180h400z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 50c0-27.6172-22.383-50-50-50h-300c-27.6172 0-50 22.3828-50 50v380c0 27.617 22.3828 50 50 50h240l110-110z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.13333333 0 0 -.13333333 0 64)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.93l107.07-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 480h-240c-27.6172 0-50-22.383-50-50v-380c0-27.6172 22.3828-50 50-50h300c27.617 0 50 22.3828 50 50v320zm-4.141-10 104.141-104.141v-315.859c0-22.0625-17.937-40-40-40h-300c-22.0586 0-40 17.9375-40 40v380c0 22.059 17.9414 40 40 40z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.93l107.07-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 480h-240c-27.6172 0-50-22.383-50-50v-380c0-27.6172 22.3828-50 50-50h300c27.617 0 50 22.3828 50 50v320zm-4.141-10 104.141-104.141v-315.859c0-22.0625-17.937-40-40-40h-300c-22.0586 0-40 17.9375-40 40v380c0 22.059 17.9414 40 40 40z",
    fill: "#d2d2d2"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m344.355 384.973 96.79-96.789v96.789z",
    fill: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440 370h-60c-27.617 0-50 22.383-50 50v60h110z",
    fill: "#efefef"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m223.047 95.5469c0 5.4101 1.933 10.0581 5.801 13.9451 3.886 3.867 8.476 5.801 13.808 5.801 5.508 0 10.176-1.934 14.004-5.801 3.828-3.887 5.742-8.535 5.742-13.9451 0-5.4883-1.914-10.1758-5.742-14.0625-3.828-3.8672-8.496-5.8008-14.004-5.8008-5.332 0-9.922 1.9531-13.808 5.8789-3.868 3.9063-5.801 8.5742-5.801 13.9844zm37.109 46.3671v-8.496h-35.117v33.867h6.387c9.648 0 17.363 2.188 23.105 6.563 5.762 4.375 8.633 10.175 8.633 17.441 0 5.566-2.168 10.469-6.504 14.668-4.336 4.219-9.336 6.328-15 6.328-5.078 0-9.492-1.953-13.242-5.82s-5.625-8.399-5.625-13.555v-2.637h-35.117v1.504c0 14.004 5.644 26.211 16.933 36.621 11.289 10.411 24.59 15.625 39.922 15.625 14.512 0 27.051-5.117 37.617-15.312 10.586-10.215 15.879-22.305 15.879-36.309 0-10.488-3.164-20.664-9.492-30.488-6.347-9.824-15.801-16.504-28.379-20",
    fill: "#e0e0e0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.58bf6323f3720cd414bed4eb93ef3a0e.svg";
export { ForwardRef as ReactComponent };